<div>
	<lib-card [isInDialog]="isInDialog()" [isForm]="true">
		<ui-text-form-field
			[title]="'Package name'"
			[isRequired]="true"
			[valueAsSignal]="form.name"
			[maxLength]="50"
			[isInDialog]="isInDialog()"
		></ui-text-form-field>

		<ui-text-form-field
			class="push-top-md"
			[title]="'Price'"
			[subtitle]="'Price is informative for your clients. We do not accept payments on your behalf.'"
			[isRequired]="false"
			[valueAsSignal]="form.price"
			[maxLength]="50"
			[isInDialog]="isInDialog()"
		></ui-text-form-field>

		<ui-text-area-form-field
			class="push-top-md"
			[title]="'Description'"
			[valueAsSignal]="form.description"
			[maxLength]="2000"
			[isInDialog]="isInDialog()"
		></ui-text-area-form-field>
	</lib-card>

	<lib-card [isInDialog]="isInDialog()" [isForm]="true" [title]="'Teaser image'" class="push-top-md">
		<ui-file-form-field
			[validation]="'images'"
			[maxFiles]="1"
			[imageCrop]="defaultSquareImageCrop"
			[isRequired]="false"
			[uploadFunction]="uploadFunction"
			[enableImageGallery]="true"
			[valueAsSignal]="form.avatar"
			(valueChange)="handleUploadImage($event)"
			[isInDialog]="isInDialog()"
		></ui-file-form-field>

		<ui-form-save-button
			[isInDialog]="isInDialog()"
			[title]="isEditForm() ? 'Save' : 'Create'"
			[saveHandler]="saveHandler()"
			[logHandler]="formLogHandler()"
		></ui-form-save-button>
	</lib-card>
</div>
